export function classifyChartSeries(rows, valueKey) {
  if (!Array.isArray(rows) || rows.length === 0) {
    return "empty";
  }

  const values = rows
    .map((row) => row?.[valueKey])
    .filter((value) => value != null && Number.isFinite(Number(value)));

  if (values.length === 0) {
    return "all-null";
  }
  if (values.length === 1) {
    return "single-point";
  }
  return "valid";
}

export function hasFiniteChartValues(rows, valueKey) {
  return classifyChartSeries(rows, valueKey) !== "empty" && classifyChartSeries(rows, valueKey) !== "all-null";
}
